import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../shared/base-api-template-service.model';
import { Core2Config } from '../shared/core2Config';
import { ApiVisa, Pagination, PagingResponseModel } from '../shared';
import { VendorContainerModel } from '../../../../../models/aggregates/vendor/vendor-container.model';
import { Observable } from 'rxjs';
import { bl_alg_cc_endpoint_hdr_RowClass } from 'projects/blg-akaun-ts-lib/src/public-api';

// https://api.akaun.dev/core2/platform/dm/vendors/

@Injectable({
  providedIn: 'root'
})
export class VendorService extends BaseApiTemplateService<VendorContainerModel> {
  protected apiUrl: string;

  constructor(http: HttpClient) {
    super();
    this.endpoint_path = Core2Config.PLATFORM_DOMAIN_URL_PREFIX + 'vendors';
    this.httpClient = http;
  }

  uploadVendorLogo(visa: ApiVisa, file: File, vendorGuid: string) {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const formData: FormData = new FormData();
    if (file) {
      formData.append('files', file);
    }
    return this.httpClient.post(
      this.apiUrl + '/add-files/' + vendorGuid,
      formData,
      this.getHttpHeader(visa)
    );
  }

  getFile(extGuid: string, visa: ApiVisa): Observable<Blob> {
    let url = this.apiUrl + '/file/' + extGuid;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + '/file/' + extGuid;
    }

    return this.httpClient.get<Blob>(url, this.getHttpHeaderBlob(visa));
  }

  getByCriteriaSysAdmin(pagination: Pagination, visa: ApiVisa) {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path + '/sysadmin-ep/query?' + pagination.getQueryKeyValues();
    }
    return this.httpClient.get<PagingResponseModel<VendorContainerModel>>(
      this.apiUrl,
      this.getHttpHeader(visa)
    );
  }

  createVendorAsSysAdmin(vendor: VendorContainerModel, apiVisa: ApiVisa) {
    const apiUrl = apiVisa.api_domain_url + Core2Config.PLATFORM_DOMAIN_URL_PREFIX + 'vendors/sysadmin-ep';
    return this.httpClient.post(apiUrl, vendor, this.getHttpHeader(apiVisa));
  }

  getVendorByGuidForSysAdmin(guid: string, apiVisa: ApiVisa) {
    const apiUrl = apiVisa.api_domain_url + Core2Config.PLATFORM_DOMAIN_URL_PREFIX + 'vendors/sysadmin-ep/' + guid;
    return this.httpClient.get(apiUrl, this.getHttpHeaderBlob(apiVisa));
  }

  updateVendorAsSysAdmin(vendor: VendorContainerModel, apiVisa: ApiVisa) {
    const apiUrl = apiVisa.api_domain_url + Core2Config.PLATFORM_DOMAIN_URL_PREFIX + 'vendors/sysadmin-ep';
    return this.httpClient.put(apiUrl, vendor, this.getHttpHeader(apiVisa));
  }

}
